import React from "react";
import {FaStar} from 'react-icons/fa';
import starCreator from "../utils/starCreator";
import { FaRegStar } from "react-icons/fa6";
import { FaRegStarHalfStroke } from "react-icons/fa6";
const Slide = ({autore, recensione, voto, classes}) => {
  const array = ["stella", "stella", "stella", "mezza", "vuota"]
  return (
    // <article className="slide">
      <article className={`slide ${classes}`}>
      <div className="review">
        <h4>{autore}</h4>
        <p>
          {recensione}
        </p>
        <div className="star-container">
           {/* {array} */}
           {/* <FaRegStarHalfStroke />
           <FaRegStar />
           <FaStar /> */}
           {starCreator(voto)}
        </div>
      </div>
    </article>
  );
};

export default Slide;
